import React from 'react';
import { Link } from 'react-router-dom';
type Variant = 'gold' | 'outline' | 'outlineLight' | 'navy';
type Size = 'sm' | 'md';
type ButtonProps = {
  children: React.ReactNode;
  to?: string;
  href?: string;
  external?: boolean;
  ariaLabel?: string;
  variant?: Variant;
  size?: Size;
  type?: 'button' | 'submit';
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
};
const base = 'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-sm font-medium tracking-[0.01em] transition-[background-color,color,border-color] duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-70';
const sizes: Record<Size, string> = {
  sm: 'h-10 px-5 text-sm',
  md: 'h-12 px-7 text-[15px]'
};
const variants: Record<Variant, string> = {
  gold: 'bg-gold text-navy hover:bg-gold-light',
  navy: 'bg-navy text-white hover:bg-navy-light',
  outline: 'border border-navy/25 text-navy hover:border-navy hover:bg-mist',
  outlineLight: 'border border-white/30 text-white hover:border-gold hover:text-gold focus-visible:ring-offset-navy'
};
export function Button({
  children,
  to,
  href,
  external,
  ariaLabel,
  variant = 'gold',
  size = 'md',
  type = 'button',
  disabled,
  onClick,
  className = ''
}: ButtonProps) {
  const classes = `${base} ${sizes[size]} ${variants[variant]} ${className}`;
  if (to) {
    return <Link to={to} className={classes} onClick={onClick} aria-label={ariaLabel} data-id="element-67" data-mp="3uhyl58l4ja46">
        {children}
      </Link>;
  }
  if (href) {
    return <a href={href} className={classes} onClick={onClick} aria-label={ariaLabel} {...external ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} data-id="element-68" data-mp="3gjqjind57kmo">
        {children}
      </a>;
  }
  return <button type={type} disabled={disabled} onClick={onClick} aria-label={ariaLabel} className={classes} data-id="element-69" data-mp="1jpnde4kgf0r4">
      {children}
    </button>;
}